import { makeAutoObservable, runInAction } from 'mobx';

import { Tab } from "../../../Common/Types/Tab";
import { StockistIssue } from "../../../Common/DTOs/StockistIssue";
import { stockiestPortalController } from "../../../Common/Controllers/StockiestPortalController";
import { textualIssueOutletController } from "./TextualIssueOutletController";

export class FilteringController {
  currentTab: Tab = "latest"
  filterDrawerOpen = false
  searchValue = ""
  lastNonSearchPath = "/latest"

  get loadingIssues() {
    return stockiestPortalController.loadingIssues;
  };

  get issues() {
    return stockiestPortalController.issues;
  }

  async pullMoreIssues() {
    await stockiestPortalController.pullMoreIssues();
  }

  get allIssuesPulled() {
    return stockiestPortalController.allIssuesPulled
  }

  get filteredIssues() {
    let issues = this.getFilteredIssuesByCategory(this.currentTab);

    return issues;
  }

  initialiseSearchFromUrl(query: string | null) {
    const normalisedQuery = query ?? "";

    if (this.searchValue === normalisedQuery) return;

    runInAction(() => this.searchValue = normalisedQuery);
  }

  getFilteredIssuesByCategory(category: Tab): StockistIssue[] {
    switch (category) {
      case "latest":
        return this.issues;
      case "upcoming":
        return textualIssueOutletController.issues;
      case "extras":
        return stockiestPortalController.issuesForExtras;
      default:
        return [];
    }
  }

  setTab = (tab: Tab) => {
    runInAction(() => this.currentTab = tab)
  }

  onSearchValueChange = (newValue: string) => {
    this.searchValue = newValue;
  }

  clearSearchValue = async () => {
    runInAction(() => this.searchValue = "")
    if (this.currentTab === "upcoming") {
      await textualIssueOutletController.searchUpcomingIssues(this.searchValue);
    } else {
      await stockiestPortalController.searchIssues();
    }
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const filteringController = new FilteringController();